if (!customElements.get('lsl-product-dimensions')) {
  customElements.define('lsl-product-dimensions', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.specification = this.dataset.specification.replace(/&nbsp;|\u00a0/g, ' ').replace(/\s+/g, ' ');
      this.hilt = this.readDimension('(?:du|des) manche(?:s)?');
      this.blade = this.readDimension('(?:de la|des) lame(?:s)?');
      if (!this.hilt) this.hilt = this.readAlternate(/(?:longueur de la poign[eé]e|poign[eé]e principale|poign[eé]es?)\s*:?\s*(?:env\.\s*)?(?:(?:alliage d.aluminium)\s*[–—-]\s*)?([\d]+(?:[,.]\d+)?\s*cm(?:\s+environ)?)/i);
      if (!this.blade) this.blade = this.readAlternate(/(?:longueur de lame\s*:|lames?(?: principale)?\s*:?\s*polycarbonate[^–—-]{0,35}[–—-])\s*([\d]+(?:[,.]\d+)?\s*cm)/i);
      this.update(this.dataset.selected);
      document.addEventListener('variant:change', event => {
        if (event.target.id !== this.dataset.form && event.target.getAttribute('form-id') !== this.dataset.form) return;
        if (event.detail?.variant) this.update(event.detail.variant.title);
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    readAlternate(pattern) { return this.specification.match(pattern)?.[1] || ''; }
    readDimension(part) {
      const match = this.specification.match(new RegExp('(?:taille|longueur)\\s+' + part + '\\s*:\\s*(.+)', 'i'));
      if (!match) return '';
      const value = match[1].split(/\b(?:taille|longueur|diamètre|poids|son|couleurs?|version|technologies?|poignée vide|lame\s*:|temps de charge)\s*(?:totale)?\s*[:\s]/i)[0]
        .split(/,\s*(?:offrant|pour|parfaitement)|\.\s+(?:Parfaitement|Cette|Le |La )/i)[0].trim().replace(/[.,;]+$/, '');
      if (!/^\d[\d\s.,/+]*\s*cm\b/i.test(value) || value.length > 110) return '';
      return value;
    }
    update(selected = '') {
      let blade = this.blade;
      const selectedSize = selected.match(/\b(\d+(?:[,.]\d+)?)\s*cm\b/i);
      if (/poign[eé]e\s+vide|empty\s+hilt/i.test(selected)) {
        blade = this.querySelector('[data-no-blade]').textContent;
      } else if (selectedSize && this.blade) {
        blade = selectedSize[1] + ' cm';
      } else if (/neopixel|proffie/i.test(selected) && /58\s*cm.*82\s*cm.*(?:neopixel|proffie)/i.test(blade)) {
        blade = '82 cm';
      }
      for (const [name, value] of [['hilt', this.hilt], ['blade', blade]]) {
        const cell = this.querySelector('[data-' + name + ']');
        cell.hidden = !value;
        cell.querySelector('dd').textContent = value;
      }
      this.hidden = !this.hilt && !this.blade;
    }
  });
}
